import { Button, Size } from '@design/components/button/Button';
import { TooltipTrigger } from '@design/components/tooltip/Tooltip';
import { TooltipContainer } from '@terminal/components/tooltip-container/TooltipContainer';
import { useTranslation } from 'react-i18next';

import { useCopyConversation } from '../hooks/useCopyConversation';
import { ConversationTask } from '../use-chat/use-chat.types';

interface CopyConversationProps {
  task: ConversationTask;
  questionOnly: boolean;
  showTooltip?: boolean;
  size?: Size;
  showingSteps?: boolean;
  conversationId: string;
}

export const CopyConversation = ({
  task,
  questionOnly,
  showingSteps = false,
  showTooltip = true,
  size = 'small',
  conversationId,
}: CopyConversationProps) => {
  const { t } = useTranslation(['common', 'chat']);

  const { isCopied, handleCopy } = useCopyConversation({
    task,
    questionOnly,
    showingSteps,
    conversationId,
    action: 'copy',
  });

  return (
    <TooltipContainer
      label={t('common:copyTooltip')}
      inPortal
      trigger={[TooltipTrigger.Hover]}
      disabled={!showTooltip}
    >
      <Button
        onClick={handleCopy}
        variant="empty"
        size={size}
        iconName={isCopied ? 'Checkmark' : 'Clone'}
      />
    </TooltipContainer>
  );
};
